// app/javascript/controllers/searchable_select_controller.js
import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ['searchInput', 'hiddenInput', 'dropdown', 'results', 'emptyMessage']
    static values = {
        url: String,
        metaFieldId: String
    }

    connect() {
        this.searchTimeout = null
        this.clickOutsideHandler = this.clickOutside.bind(this)
        document.addEventListener('click', this.clickOutsideHandler)
    }

    disconnect() {
        document.removeEventListener('click', this.clickOutsideHandler)
    }

    async onSearch(event) {
        clearTimeout(this.searchTimeout)
        const searchTerm = event.target.value

        if (searchTerm.length < 2) {
            this.hideResults()
            return
        }

        this.searchTimeout = setTimeout(async () => {
            try {
                const response = await fetch(`${this.urlValue}?term=${searchTerm}&meta_field_id=${this.metaFieldIdValue}`)
                const data = await response.json()

                this.showResults(data.results)
            } catch (error) {
                console.error('Search failed:', error)
            }
        }, 300)
    }

    showResults(results) {
        this.dropdownTarget.classList.remove('hidden')

        if (results.length === 0) {
            this.emptyMessageTarget.textContent = 'No results found'
            this.emptyMessageTarget.classList.remove('hidden')
            this.resultsTarget.classList.add('hidden')
            return
        }

        this.emptyMessageTarget.classList.add('hidden')
        this.resultsTarget.classList.remove('hidden')

        this.resultsTarget.innerHTML = results.map(result => `
      <div class="px-4 py-2 hover:bg-gray-100 cursor-pointer"
           data-action="click->searchable-select#selectResult"
           data-id="${result.id}"
           data-label="${result.text}">
        ${result.text}
      </div>
    `).join('')
    }

    selectResult(event) {
        const {id, label} = event.currentTarget.dataset

        this.hiddenInputTarget.value = id
        this.searchInputTarget.value = label
        this.hideResults()

        // Trigger form save
        const ev = new Event('change', {bubbles: true})
        this.hiddenInputTarget.dispatchEvent(ev)
    }

    onFocus() {
        if (this.searchInputTarget.value.length >= 2) {
            this.dropdownTarget.classList.remove('hidden')
        }
    }

    onBlur() {
        // Delayed hide to allow click events to fire
        setTimeout(() => this.hideResults(), 200)
    }

    hideResults() {
        this.dropdownTarget.classList.add('hidden')
    }

    clickOutside(event) {
        if (!this.element.contains(event.target)) {
            this.hideResults()
        }
    }
}